/* src/app/core/modules/shared/components/modal-tooltip/modal-tooltip.component.scss */
/*# sourceMappingURL=/avvera/dev/modal-tooltip.component.css.map */
